import { Controller } from "stimulus";
import _ from 'lodash';
import morphDom from 'morphdom';
import RequestQueue from '../classes/RequestQueue';

const DEFAULT_SEARCH_RESULTS_NUMBER = 5;
export default class extends Controller {
  static targets = ['input', 'resultContainer', 'result', 'button']
  static values = { searchResultsNumber: Number,  searchUrl: String, method: String, additionalData: Object, result: String }
  static classes = ['selectedItem']

  connect() {
    this.currentSelection = -1;
    if (!this.hasSearchResultsNumberValue) {
      this.searchResultsNumberValue = DEFAULT_SEARCH_RESULTS_NUMBER;
    }
  }

  handleInput = _.debounce(e => {
    const searchValue = e.target.value;
    this.inputTarget.dataset.result = searchValue;
    this.inputTarget.dataset.displayResult = searchValue;
    this.__renderSearchResult(searchValue);
  }, 300);

  handleButtonClick() {
    this.__resetSearchResultContainer();
  }

  handleKeyInput(e) {
    if (e.keyCode == 40) {
      // down
      this.currentSelection++;
      this.highlightSelection();
    } else if (e.keyCode == 38) {
      //up
      this.currentSelection--;
      if (this.currentSelection < 0) {
        this.currentSelection = this.resultContainerTarget.childElementCount - 1;
      }
      this.highlightSelection();
    } else if (e.keyCode == 13) {
      // enter
      e.preventDefault();
      if (this.currentSelection !== -1) {
        let selectedChild = this.resultContainerTarget.querySelector(`[data-index="${this.currentSelection}"]`);
        selectedChild.click();
      }
    }
  }

  handleResultClicked(e) {
    e.preventDefault();
    this.resultValue = e.target.dataset.result;
    this.inputTarget.dataset.result = e.target.dataset.result;
    this.inputTarget.dataset.displayResult = e.target.dataset.displayResult;
    this.inputTarget.value = e.target.dataset.displayResult;
    this.__resetSearchResultContainer();
  }

  highlightSelection() {
    if (!this.hasResultContainerTarget) return;
    this.removeHighLightSelection();
    this.currentSelection %= this.resultContainerTarget.childElementCount;
    this.resultTargets[this.currentSelection].classList.add(this.selectedItemClass);
  }

  removeHighLightSelection() {
    if (!this.hasResultContainerTarget) return;
    this.resultTargets.forEach(resultTarget => {
      resultTarget.classList.remove(this.selectedItemClass);
    });
  }

  async __renderSearchResult(searchValue) {
    if (_.isEmpty(searchValue)) {
      this.__resetSearchResultContainer();
      return;
    }
    const resultContainer = await this.__fetchSearchResult(searchValue);
    morphDom(this.resultContainerTarget, resultContainer);
  }

  async __fetchSearchResult(searchValue) {
    let data = _.merge(this.additionalDataValue, { search_value: searchValue, size: this.searchResultsNumberValue });
    const { data: searchResultsDom } = await RequestQueue.addToQueue({
      method: this.methodValue || 'get',
      url: this.searchUrlValue,
      data
    })
    return searchResultsDom;
  }

  __resetSearchResultContainer() {
    this.currentSelection = -1;
    if (this.hasResultContainerTarget) {
      this.resultContainerTarget.classList.add('t-hidden');
    }
  }
}
